// src/components/operationCenter/widgets/token/performance/TwVsBenchmarksWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import TokenVsBenchmarksReturnsChart from "@/components/tokenPage/performance/TokenVsBenchmarksReturnsChart";

const TwVsBenchmarksWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <TokenVsBenchmarksReturnsChart />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwVsBenchmarksWidget;
